/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from '../../../services'


export const getAccountMappingByID = createAsyncThunk('mapping/getAccountMappingByID', async (params, { rejectWithValue }) => {
    try {
        const data = await api.mapping.getAccountMappingByID(params);
        return Promise.resolve(data);

    } catch (error) {
        return rejectWithValue(error.message);
    }
})
export const getAccountMappingForUserID = createAsyncThunk('mapping/getAccountMappingForUserID', async (params, { rejectWithValue }) => {
    try {
        const data = await api.mapping.getAccountMappingForUserID(params)


        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})
export const getAccountMappingHistory = createAsyncThunk('mapping/getAccountMappingHistory', async (params, { rejectWithValue }) => {
    try {
        const data = await api.mapping.getAccountMappingHistory(params)


        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})
export const getAllAccountMappings = createAsyncThunk('mapping/getAllAccountMappings', async (params, { rejectWithValue }) => {
    try {
        const data = await api.mapping.getAllAccountMappings(params)


        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})